import { CountryCodeTypeToAutosuggestData } from './types';

/** used for autosuggest 'at' param */
export const AUTOSUGGEST_DEFAUL_DATA: CountryCodeTypeToAutosuggestData = {
  POL: { coords: '52.237049,21.017532' }, // WARSAW
  SVN: { coords: '46.05846459845126,14.49913680216699' }, // Ljubljana
  DEU: { coords: '52.51884820875157,13.395886491739786' }, // Berlin
  UKR: { coords: '50.45091240710162,30.56083654159563' }, // Kyiv
  CYP: { coords: '35.185566,33.382276' }, // Nicosia
  CZE: { coords: '50.07359466842247,14.435812867001914' }, // Prague,
};

export const AUTOSUGGEST_DEFAUL_LIMIT = 5;
